import { word } from "@modules/core/utils/i18n"
import { getFormErrorMessage, isFormFieldInValid } from "@modules/formik/formikUtils"
import { AthleteNoteFormikType } from "@modules/sessionBlock/notes/noteFormikTypes"
import { useSessionFormContext } from "@modules/sessions/hooks/useSessionFormContext"
import { useSessionSidebar } from "@modules/sessions/hooks/useSessionSidebar"
import { HUButton } from "@modules/ui/components/huButton"
import { HUText } from "@modules/ui/components/huText"
import { HURichTextInput } from "@modules/ui/components/richText/huRichTextInput"
import { formatTextToRichText } from "@modules/ui/components/richText/richTextUtils"
import { useTheme } from "styled-components"

type Props = {} & React.HTMLAttributes<HTMLDivElement>

export const NoteForAthletesForm: React.FC<Props> = ({ ...props }) => {
  const theme = useTheme()
  const { sidebarNavigateBack } = useSessionSidebar()
  const { setInitialUpdatedBlock, formik, updatedBlockIndex } = useSessionFormContext()

  const formikNameBase = `blocks[${updatedBlockIndex}].content`
  const formikValue =
    updatedBlockIndex !== null ? (formik.values.blocks[updatedBlockIndex]?.content as AthleteNoteFormikType) : null

  return (
    <div className="flex flex-column gap-5 session-block-form flex-grow-1" {...props}>
      <div className="flex flex-column gap-2 flex-grow-1">
        {updatedBlockIndex !== null && (
          <HUText fontStyle="LS" color={theme.neutralColor700} className="uppercase">
            {`(${updatedBlockIndex + 1}) ${word("program.planning.create.exercise.block_plural", { count: updatedBlockIndex })}`}
          </HUText>
        )}

        <HUText fontStyle="TL">{word("sessionForm.blocks.add_note_for_athletes.title")}</HUText>
        <HUText fontStyle="BS">{word("sessionForm.blocks.add_note_for_athletes.description")}</HUText>
      </div>

      {/* Note content input */}
      <div className="card p-3">
        <HURichTextInput
          value={formatTextToRichText(formikValue?.note ?? "")}
          onChange={(value) => {
            formik.setFieldValue(`${formikNameBase}.note`, value)
          }}
          label={word("sessionForm.blocks.add_note_for_athletes.note_content")}
          isRequiredInput
          maxLength={65000}
          paragrapheFontStyle="BM"
          isInvalid={isFormFieldInValid(`${formikNameBase}.note`, formik)}
          error={getFormErrorMessage(`${formikNameBase}.note`, formik)}
        />
      </div>

      <div className="flex flex-row align-items-center justify-content-between">
        <HUButton
          type="Default"
          colorType="Primary"
          size="L"
          text={word("global.check")}
          className="p-button-primary w-full"
          onClick={async () => {
            formik.values.blocks.map((_, index) => {
              formik.setFieldTouched(`blocks[${index}].content.note`)
            })
            if (formik.validateField) {
              await formik.validateField("blocks")
              if ((formik.errors && !formik.errors.hasOwnProperty("blocks")) || !formik.errors) {
                setInitialUpdatedBlock(undefined)
                sidebarNavigateBack(false)
              }
            }
          }}
        />
      </div>
    </div>
  )
}
